<div class="dialog-panel">
  <div class="dialog-content">
    @if (loading) {
      <div class="spinner-container p-absolute">
        <mat-spinner class="primary" [diameter]="30"></mat-spinner>
      </div>
    }
    <form [ngClass]="{ 'v-hidden': loading }" [formGroup]="form" (submit)="onSubmit()">
      <div class="dialog-header">
        <h1 class="dialog-title dot">{{ 'auth.reset_password' | transloco }}</h1>
      </div>
      @if (!resetSuccess) {
        <div class="dialog-body">
          <!-- <p class="info">
          {{ 'auth.reset_pwd_info' | transloco }}
        </p> -->
          <div class="form-field-container pb-5">
            <div class="form-field-label">
              {{ 'form.field.email' | transloco }}
            </div>
            <mat-form-field class="form-field" [floatLabel]="'auto'">
              <input matInput formControlName="email" required />
              @if (getFormControl('email').invalid) {
                <mat-error>
                  @if (getFormControl('email').errors.required) {
                    {{ 'form.error.required' | transloco }}
                  }
                  @if (getFormControl('email').errors.email) {
                    {{ 'form.error.invalid_email' | transloco }}
                  }
                  @if (getFormControl('email').errors.no_user) {
                    {{ 'form.error.no_user' | transloco }}
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="auth-other-actions mt-5">
            <button type="button" class="btn btn-text" (click)="handleToSignIn($event)">
              {{ 'auth.already_have_account' | transloco }}
              <span>
                {{ 'auth.signin_here' | transloco }}
              </span>
            </button>
          </div>
        </div>
        <div class="dialog-bottom">
          <button type="submit" class="btn btn-primary d-block w-100" [disabled]="form.invalid">
            {{ 'global.reset' | transloco }}
          </button>
        </div>
      } @else {
        <div class="dialog-body">
          <p class="info text-center">
            {{ 'auth.check_your_email' | transloco }}
          </p>
        </div>
      }
    </form>
  </div>
</div>
